/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys } from "./queryKeys";

export const tokenQueryOptions = (params, queryParams) =>
  queryOptions({
    queryKey: queryKeys.token.all,
    queryFn: async () => {
      const response = await fetcher({ method: "POST", url: "/public/auth/token", data: params });
      return response.token;
    },
    ...queryParams,
  });

export const useToken = (params, queryParams) => useQuery(tokenQueryOptions(params, queryParams));
export const useSuspenseToken = (params, queryParams) => useSuspenseQuery(tokenQueryOptions(params, queryParams));
